import React from 'react';
import '../EvaluacionRiesgoModal.css';

const EvaluacionRiesgoModal1 = ({ siguiente, onClose, formData, setFormData }) => {
  const handleNext = () => {
    if (formData.extension != null && formData.caracteristica != null) {
      siguiente();
    }
    // Si no están ambos seleccionados, no haces nada (o podrías mostrar alerta)
  };

  const handleSelect = (campo, valor) => {
    setFormData(prev => ({ ...prev, [campo]: valor }));
  };

  // Comprueba si ambos están seleccionados
  const isNextEnabled =
    formData.extension != null &&
    formData.caracteristica != null;

  const extensiones = [
    {
      text: `- Casos o evento diseminado en un municipio (LET o PN).\n- Casos aislados en una sola Zona No Municipalizada.\n- Casos en varias Instituciones de un mismo municipio.`,
      value: 5,
    },
    {
      text: `- Casos o evento con extensión a varios municipios.\n- Casos diseminados en una o varias zonas no municipalizadas.`,
      value: 15,
    },
    {
      text: `- Evento con extensión en varios países limítrofes.\n- Casos o Evento con extensión a varios municipios y sus fronteras internacionales.\n- Casos diseminados en una o varias zonas no municipalizadas y/o en sus fronteras nacionales e internacionales.`,
      value: 50,
    },
    {
      text: `- Casos aislados en un solo municipio (LET-PN).\n- Casos notificados en una sola vivienda.\n- Casos en una sola Institución.`,
      value: 1,
    },
  ];

  const caracteristicas = [
    {
      text: `- Evento emergente, re emergente o de etiología desconocida que no ha ocasionado muertes.\n- Evento con aberración positiva en brote.\n- Evento de interés en salud pública con muertes relacionadas.\n- Tasa de ataque alta 2 a 5% del municipio.\n- Evento de alta patogenicidad, virulencia y transmisibilidad`,
      value: 15,
    },
    {
      text: `- Evento epidémico conocido recurrente en el área.\n- Evento con aberración epidémica positiva o en zona de alerta.\n- Tasa de ataque moderada a alta 1 a 2% del municipio.\n- Posibilidad de diseminación por cantidad de susceptibles.\n- Baja patogenicidad, virulencia y transmisibilidad.`,
      value: 5,
    },
    {
      text: `- Evento endémico conocido.\n- Evento en zona de seguridad.\n- Tasa de ataque baja < 1% del municipio.`,
      value: 1,
    },
    {
      text: `- Evento de etiología desconocida con muertes.\n- Evento en alerta internacional, ESPII, evento en el marco de RSI con inminente ingreso al País.\n- Tasa de ataque muy elevada más del 5% del municipio.\n- Tasa de ataque en el área mayor del 50%.`,
      value: 50,
    },
  ];

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 className="text-center mb-3">EVALUACIÓN DEL RIESGO</h3>
        <h5 className="text-center">IMPACTO HUMANO</h5>

        <div className="row">
          <div className="col-md-6">
            <h6>Extensión Geográfica</h6>
            <div className="cuadros-container">
              {extensiones.map((item, index) => (
                <div
                  key={index}
                  className={`opcion-cuadro ${formData.extension === item.value ? 'seleccionado' : ''}`}
                  onClick={() => handleSelect('extension', item.value)}
                >
                  <input
                    type="radio"
                    name="extension"
                    checked={formData.extension === item.value}
                    onChange={() => handleSelect('extension', item.value)}
                  />
                  <pre className="opcion-texto">{item.text}</pre>
                </div>
              ))}
            </div>
          </div>

          <div className="col-md-6">
            <h6>Características del evento</h6>
            <div className="cuadros-container">
              {caracteristicas.map((item, index) => (
                <div
                  key={index}
                  className={`opcion-cuadro ${formData.caracteristica === item.value ? 'seleccionado' : ''}`}
                  onClick={() => handleSelect('caracteristica', item.value)}
                >
                  <input
                    type="radio"
                    name="caracteristica"
                    checked={formData.caracteristica === item.value}
                    onChange={() => handleSelect('caracteristica', item.value)}
                  />
                  <pre className="opcion-texto">{item.text}</pre>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-secondary me-2" onClick={onClose}>
            Cerrar
          </button>
          <button
            className="btn btn-primary"
            onClick={handleNext}
            disabled={!isNextEnabled}  // aquí se deshabilita si no hay selección completa
          >
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
};

export default EvaluacionRiesgoModal1;
